import { useNavigate } from "react-router-dom";
import type { queryResults } from "./models/SharedInterfaces";
import { SilentLogin } from "./SharedAuthentication";
import { useEffect } from "react";
//import { useNavigate } from "react-router-dom";

//let userClaims: any = null;

//export async function checkAuth() {
//    useEffect(() => {
//        const urlParams = new URLSearchParams(window.location.search);
//        const error = urlParams.get('error');

//        if (error === 'login_required' || error === 'interaction_required') {
//            // The silent login check failed. Provide a UI "Login" button for the user to click.
//            //console.log("User is not logged into the Identity Server. Showing interactive login UI.");
//            window.location.replace("/bff/login");
//        }
//    }, []);


//    var req = new Request("/bff/user", {
//        headers: new Headers({
//            "X-CSRF": "1",
//        }),
//    });

//    try {
//        var resp = await fetch(req);
//        if (resp.ok) {
//            userClaims = await resp.json();
//            return true;
//        } else if (resp.status === 401) {
//            const currentUrl = window.location.href;
//            var encodeUrl = encodeURIComponent(currentUrl);
//            window.location.replace("/bff/login?prompt=none&returnUrl=" + encodeUrl);
//            return false;
//        } else {
//            return false;
//        }
//    } catch (e) {
//        return false;
//    }
//}

//let retry = false;

//export const SilentLoginLocal = async () => {
//    let navigate = useNavigate();

//    useEffect(() => {
//        retry = false;
//        const urlParams = new URLSearchParams(window.location.search);
//        const error = urlParams.get('error');

//        if (error === 'login_required' || error === 'interaction_required') {
//            // The silent login check failed. Provide a UI "Login" button for the user to click.
//            //console.log("User is not logged into the Identity Server. Showing interactive login UI.");
//            navigate("/bff/login");
//        }
//    }, []);

//    if (!retry) {
//        retry = true;
//        const currentUrl = window.location.href;
//        var encodeUrl = encodeURIComponent(currentUrl);
//        navigate("/bff/login?prompt=none&returnUrl=" + encodeUrl);
//    } else {
//        retry = false;
//        navigate("/bff/login");
//    }

//}


//let navigate = useNavigate();
//check if user is authenticated and redirect to login if not
//var isAuth = await checkAuth();
//if (!isAuth) {
//    window.location.replace("/bff/login");
//    throw new Error("Unauthorized: Please log in to continue.");
//}
//var isAuth = true;
//if (userClaims == null) {
//    isAuth = await checkAuth();
//}

//export const GetQuery = async (url: string) => {
//    const baseURL = window.location.origin;
//    const apiURL = new URL('api/' + url, baseURL);

//    var req = new Request(apiURL, {
//        headers: new Headers({
//            "X-CSRF": "1",
//        }),
//    });

//    try {
//        var resp = await fetch(req);
//        if (resp.ok) {
//            let data = await resp.json();
//            let result: queryResults = {
//                data: data,
//                error: false,
//                errorMessage: ""
//            };
//            return result;
//        }
//        else if (resp.status == 401) {



//            //var url = `/bff/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
//            //navigate(url);
//            //window.location.replace(url);
//            //await SilentLogin();
//        }
//        let result: queryResults = {
//            data: null,
//            error: true,
//            errorMessage: resp.statusText
//        };
//        return result;
//    } catch (e) {
//        let result: queryResults = {
//            data: null,
//            error: true,
//            errorMessage: ""
//        };
//        return result;
//    }
//}

export const GetQuery = async (url: string) => {
    var resp = await authenticatedFetch(url);
    if (resp.ok) {
        let data = await resp.json();
        let result: queryResults = {
            data: data,
            error: false,
            errorMessage: ""
        };
        return result;
    }
    //error message
    let result: queryResults = {
        data: null,
        error: true,
        errorMessage: resp.statusText
    };
    return result;
}

export async function bffFetch(url: string, options: RequestInit = {}) {
    const baseURL = window.location.origin;
    const apiURL = new URL('api/' + url, baseURL);

    const defaultHeaders = {
        'X-CSRF': '1', // Duende BFF strictly requires this header for API/management requests
        'Content-Type': 'application/json',
    };

    const config: RequestInit = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
        // Crucial for sending/receiving the Duende encrypted session cookie
        credentials: 'same-origin',
    };

    return fetch(apiURL, config);
}

export interface BffClaim {
    type: string;
    value: any;
}

export type BffUserResponse = BffClaim[];

export async function authenticatedFetch(url: string, options: RequestInit = {}): Promise<Response> {
    let response = await bffFetch(url, options);

    // If Duende returns a 401, token renewal or sliding cookie window failed
    if (response.status === 401) {
        try {
            // Prompt Duende backend to extend the session window
            const refreshResponse = await checkUserAuth(); //bffFetch('/bff/user?slide=true');

            if (refreshResponse.ok) {
                const userData: BffUserResponse = await refreshResponse.json();

                // Confirm authentication status by searching for the Subject claim
                const isAuthenticated = userData.some(claim => claim.type === 'sub');

                if (isAuthenticated) {
                    // Re-try the primary fetch invocation exactly once
                    return await bffFetch(url, options);
                }
            }
        } catch (error) {
            console.error("Silent token refresh failed:", error);
        }

        // Force application route boot sequence back to authorization layer
        const returnUrl = encodeURIComponent(window.location.pathname);
        window.location.href = `/bff/login?returnUrl=${returnUrl}`;
    }

    return response;
}


export const checkUserAuth = async () => {
    var req = new Request("/bff/user", {
        credentials: 'include',
        headers: new Headers({
            "X-CSRF": "1",
        }),
    });
    return fetch(req);
}

export const PostQuery = async (url: string, objectJsonString: string) => {
    //check if user is authenticated and redirect to login if not
    //var isAuth = await checkAuth();
    //if (!isAuth) {
    //    throw new Error("Unauthorized: Please log in to continue.");
    //}

    const baseURL = window.location.origin;
    const apiURL = new URL('api/' + url, baseURL);

    try {
        const resp = await fetch(apiURL, {
            method: 'POST', // *set the method to POST*
            headers: {
                'Content-Type': 'application/json', // Indicate the content type is JSON
                'X-CSRF': '1'
            },
            body: objectJsonString // *stringify the data for the body - passed in as a Json String*
        });
        if (resp.ok) {
            let data = await resp.json();
            let result: queryResults = {
                data: data,
                error: false,
                errorMessage: ""
            };
            return result;
        } else if (resp.status === 401) {
            //let navigate = useNavigate();
            var url = `/bff/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
            window.location.replace(url);
        }
        let result: queryResults = {
            data: null,
            error: true,
            errorMessage: ""
        };
        return result;
    } catch (e) {
        let result: queryResults = {
            data: null,
            error: true,
            errorMessage: ""
        };
        return result;
    }
}

export const PostFormDataQuery = async (url: string, formData: FormData) => {
    //check if user is authenticated and redirect to login if not
    //var isAuth = await checkAuth();
    //if (!isAuth) {
    //    throw new Error("Unauthorized: Please log in to continue.");
    //}

    const baseURL = window.location.origin;
    const apiURL = new URL('api/' + url, baseURL);

    try {
        const resp = await fetch(apiURL, {
            method: 'POST', // *set the method to POST*
            headers: {
                'X-CSRF': '1'
            },
            body: formData // *stringify the data for the body*
        });

        if (resp.ok) {
            let data = await resp.json();
            let result: queryResults = {
                data: data,
                error: false,
                errorMessage: ""
            };
            return result;
        } else if (resp.status === 401) {
            //let navigate = useNavigate();
            var url = `/bff/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
            window.location.replace(url);
        }
        let result: queryResults = {
            data: null,
            error: true,
            errorMessage: ""
        };
        return result;
    } catch (e) {
        let result: queryResults = {
            data: null,
            error: true,
            errorMessage: ""
        };
        return result;
    }
};

export const CheckPermissions = async (permissionName: string) => {
    const apiUrl = 'CheckUserPermission?Permission=' + permissionName;
    var result = await GetQuery(apiUrl);

    if (result.error) {
        return false;
    } else {
        if (result.data == true) {
            return true;
        }
        return false;
    }
}

export const GetSystemCompanyId = async () => {
    const apiUrl = "GetUserSystemCompanyId";
    var result = await GetQuery(apiUrl);

    if (result.error) {
        return 0;
    } else {
        return result.data.systemCompanyId;
    }
}

export const GetCustomers = async () => {
    const apiUrl = "GetCustomersForDropdown";
    var result = await GetQuery(apiUrl);

    if (result.error) {
        return [];
    } else {
        return result.data;
    }
}

export const DownloadFile = async (url: string, fileName: string) => {
    //check if user is authenticated and redirect to login if not
    //var isAuth = await checkAuth();
    //if (!isAuth) {
    //    throw new Error("Unauthorized: Please log in to continue.");
    //}

    const baseURL = window.location.origin;
    const apiURL = new URL('api/' + url, baseURL);

    var req = new Request(apiURL, {
        headers: new Headers({
            "X-CSRF": "1",
        }),
    });

    try {
        const response = await fetch(req);
        if (response.status === 401) {
            //let navigate = useNavigate();
            var url = `/bff/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
            window.location.replace(url);
        }

        const blob = await response.blob();

        var fileheader = response.headers.get('Content-Disposition');
        if (fileheader) {
            fileName = fileheader.split('filename=')[1].split(';')[0];
            fileName = fileName.replaceAll('"', '');
        }

        // Create blob link and download
        const blobURL = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = blobURL;
        link.setAttribute('download', fileName);

        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Cleanup
        window.URL.revokeObjectURL(blobURL);
    } catch (error) {
        console.error('Download failed:', error);
    }
}

export const DownloadFilesViaPost = async (url: string, objectJsonString: string, fileName: string) => {
    //check if user is authenticated and redirect to login if not
    //var isAuth = await checkAuth();
    //if (!isAuth) {
    //    throw new Error("Unauthorized: Please log in to continue.");
    //}

    const baseURL = window.location.origin;
    const apiURL = new URL('api/' + url, baseURL);

    try {
        const response = await fetch(apiURL, {
            method: 'POST', // *set the method to POST*
            headers: {
                'Content-Type': 'application/json', // Indicate the content type is JSON
                'X-CSRF': '1'
            },
            body: objectJsonString // *stringify the data for the body*
        });

        if (response.status === 401) {
            var url = `/bff/login?returnUrl=${encodeURIComponent(window.location.pathname)}`;
            window.location.replace(url);
        }

        const blob = await response.blob();
        // Create blob link and download
        const blobURL = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = blobURL;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(blobURL);
    } catch (e) {
        console.error('Download failed:', e);
    }
}

